module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./FindPasswordView.js"));
	}, "FindPasswordView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=FindPasswordView!./src/pages/Login/FindPassword/FindPasswordView.js
// module id = 863
// module chunks = 431